import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=1063110e&"
import script from "./ProductGrid.vue?vue&type=script&lang=js&"
export * from "./ProductGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports